import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const ACTIVE_TENANT_STORAGE_KEY = 'activeTenantId'

function readFromStorage(): number | undefined {
  if (typeof window === 'undefined') return undefined
  const raw = localStorage.getItem(ACTIVE_TENANT_STORAGE_KEY)
  return raw ? Number(raw) : undefined
}

export interface TenantState {
  activeTenantId: number | undefined
  setActiveTenantId: (id: number | undefined) => void
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      activeTenantId: undefined,
      setActiveTenantId: (id) => {
        if (id != null) localStorage.setItem(ACTIVE_TENANT_STORAGE_KEY, String(id))
        else localStorage.removeItem(ACTIVE_TENANT_STORAGE_KEY)
        set({ activeTenantId: id })
      },
    }),
    {
      name: 'tenant-storage',
      partialize: (s) => ({ activeTenantId: s.activeTenantId }),
      onRehydrateStorage: () => (state) => {
        if (state?.activeTenantId != null) {
          localStorage.setItem(ACTIVE_TENANT_STORAGE_KEY, String(state.activeTenantId))
        }
      },
    },
  ),
)

/** Hook to get active tenant ID - components using this re-render when tenant changes */
export function useActiveTenantId(): number | undefined {
  const stored = useTenantStore((s) => s.activeTenantId)
  if (stored != null) return stored
  return readFromStorage()
}
